import React from "react";
import styled from "styled-components";
import { EnvironmentEnum, getEnvironment } from "../../../EnvironmentUtils";

// `title` here is the long form for assistive technology, exposed via aria-label — not a native title
// attribute, which issue 42377 rules out.
//
// Shape and colours follow the prototype's ENV table: a pill with a hairline
// border and a brighter dot than the text, so the badge reads as a state marker
// rather than as a tag.
const ENVIRONMENTS = {
    [EnvironmentEnum.APP]: {
        label: "LIVE",
        title: "Produktion",
        tone: "live",
    },
    [EnvironmentEnum.STAGING]: {
        label: "STAGING",
        title: "Staging-Umgebung — keine Produktionsdaten",
        tone: "staging",
    },
    [EnvironmentEnum.ITEST]: {
        label: "ITEST",
        title: "Testsystem — keine Produktionsdaten",
        tone: "itest",
    },
    [EnvironmentEnum.DEV]: {
        label: "DEV",
        title: "Lokale Entwicklungsumgebung",
        tone: "dev",
    },
};

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    flex: none;
    width: fit-content;
    padding: 1px 6px;
    border-radius: var(--pw-radius-pill);
    border: 1px solid ${(props) => `var(--pw-env-${props.$tone}-border)`};
    background: ${(props) => `var(--pw-env-${props.$tone}-bg)`};
    color: ${(props) => `var(--pw-env-${props.$tone}-fg)`};
    font-size: 9px;
    font-weight: var(--pw-weight-bold);
    letter-spacing: 0.06em;
`;

const Dot = styled.span`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    flex: none;
    background: ${(props) => `var(--pw-env-${props.$tone}-dot)`};
`;

export const EnvironmentBadge = () => {
    const environment = ENVIRONMENTS[getEnvironment()];

    if (!environment) {
        return null;
    }

    return (
        <Badge $tone={environment.tone} aria-label={environment.label + " — " + environment.title} data-cy="environment-badge">
            <Dot $tone={environment.tone} aria-hidden="true" />
            {environment.label}
        </Badge>
    );
};

export default EnvironmentBadge;
